import { useVirtualizer } from "@tanstack/react-virtual";

type RowVirtualizerOptions = Parameters<
    typeof useVirtualizer<HTMLDivElement, Element>
>[0];

/**
 * `useVirtualizer` behind a plain-values boundary so the body compiles. The
 * virtualizer is one long-lived object whose getters return new results
 * while it stays the same, so a compiled caller would cache them stale; the
 * compiler skips this hook instead. Render with `virtualItems`, `totalSize`,
 * and `rangeEndIndex`; use `virtualizer` only in effects and handlers.
 */
export const useRowVirtualizer = (options: RowVirtualizerOptions) => {
    // oxlint-disable-next-line react/incompatible-library -- the one uncompiled seam; callers get plain values
    const virtualizer = useVirtualizer(options);
    return {
        virtualizer,
        virtualItems: virtualizer.getVirtualItems(),
        totalSize: virtualizer.getTotalSize(),
        rangeEndIndex: virtualizer.range?.endIndex ?? -1,
    };
};
